import { ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 2
};
const _hoisted_2 = {
  key: 3
};
import useDetailHooks from '@/views/goodsManage/goodsSetting/hooks/useDetailHooks';
import { usePass } from '@/views/goodsManage/goodsSetting/hooks/usePass';
export default /*#__PURE__*/_defineComponent({
  __name: 'WeiXinJudgeModal',
  props: {
    modalVisible: {
      type: Boolean,
      required: true
    },
    dataSource: {
      type: Array,
      required: true,
      default: () => []
    },
    isToTest: {
      type: Boolean,
      default: false
    },
    prodChnl: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modalVisible', 'searchData'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const prodChnlRef = ref(props.prodChnl);
    const {
      prodTypeOptions
    } = useDetailHooks();
    const {
      loading,
      changePrice
    } = usePass(prodChnlRef, () => {
      emit('update:modalVisible', false);
      emit('searchData');
    });
    const columns = [{
      title: '商品类型',
      dataIndex: 'prodType'
    }, {
      title: '内购ID',
      dataIndex: 'prodId'
    }, {
      title: '系统',
      dataIndex: 'os',
      width: 120
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '当前价格',
      dataIndex: 'prodPrice',
      key: 'prodPrice'
    }, {
      title: '修改后价格',
      dataIndex: 'price',
      key: 'price'
    }];
    const osList = [{
      label: '安卓',
      value: 1
    }, {
      label: 'ios',
      value: 2
    }];
    watch(() => props.prodChnl, n => {
      prodChnlRef.value = n;
    });
    const closeModal = () => {
      emit('update:modalVisible', false);
    };
    return (_ctx, _cache) => {
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "以下商品将进行价格变更",
        width: "1200px",
        centered: "",
        open: __props.modalVisible,
        onCancel: closeModal,
        onOk: _cache[0] || (_cache[0] = $event => _unref(changePrice)(__props.dataSource, __props.isToTest ? 0 : 10)),
        "confirm-loading": _unref(loading),
        "ok-text": "确定修改",
        "cancel-text": "稍后"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_table, {
          columns: columns,
          "data-source": __props.dataSource,
          pagination: false,
          scroll: {
            y: 600
          }
        }, {
          bodyCell: _withCtx(({
            column,
            record
          }) => {
            var _unref$find, _osList$find, _record$officePrices, _record$testPrices, _record$testPrices2, _record$officePrices2;
            return [column.dataIndex === 'prodType' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString((_unref$find = _unref(prodTypeOptions).find(item => item.value === record.prodType)) === null || _unref$find === void 0 ? void 0 : _unref$find.label), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'os' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createTextVNode(_toDisplayString((_osList$find = osList.find(item => item.value === record.os)) === null || _osList$find === void 0 ? void 0 : _osList$find.label), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodPrice' ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(record['prodPriceCurrency']) + _toDisplayString(__props.isToTest ? (_record$officePrices = record['officePrices']) === null || _record$officePrices === void 0 || (_record$officePrices = _record$officePrices[0]) === null || _record$officePrices === void 0 ? void 0 : _record$officePrices.price : (_record$testPrices = record['testPrices']) === null || _record$testPrices === void 0 || (_record$testPrices = _record$testPrices[0]) === null || _record$testPrices === void 0 ? void 0 : _record$testPrices.price), 1)) : _createCommentVNode("", true), column.dataIndex === 'price' ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(record['prodPriceCurrency']) + _toDisplayString(__props.isToTest ? (_record$testPrices2 = record['testPrices']) === null || _record$testPrices2 === void 0 || (_record$testPrices2 = _record$testPrices2[0]) === null || _record$testPrices2 === void 0 ? void 0 : _record$testPrices2.price : (_record$officePrices2 = record['officePrices']) === null || _record$officePrices2 === void 0 || (_record$officePrices2 = _record$officePrices2[0]) === null || _record$officePrices2 === void 0 ? void 0 : _record$officePrices2.price), 1)) : _createCommentVNode("", true)];
          }),
          _: 1
        }, 8, ["data-source"])]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});